import { Component, HostListener, OnInit } from '@angular/core';
import { DistribuidorDeContenidosService } from '../servicio/distribuidor-de-contenidos.service';

@Component({
  selector: 'app-nuestra-historia',
  templateUrl: './nuestra-historia.component.html',
  styleUrls: ['./nuestra-historia.component.css']
})
export class NuestraHistoriaComponent implements OnInit {
  titulo: string;
  descripcion: string;
  subtituloA: string
  subtituloB: string
  scrWidth: any;
  scrHeight: any;

  @HostListener('window:resize', ['$event'])

  getScreenSize(event?) {
    if (window.innerWidth > 640) {
      this.scrWidth = 700;
      this.scrHeight = 400;
    } else if (window.innerWidth > 400 && window.innerWidth <= 640) {
      this.scrWidth = window.innerWidth / 2;
      this.scrHeight = window.innerHeight / 2;
    } else {
      this.scrWidth = window.innerWidth;
      this.scrHeight = window.innerHeight / 3;
    }
  }

  constructor(private distribuidor: DistribuidorDeContenidosService) {
    this.getScreenSize();
    this.titulo = distribuidor.contenidoNuestraHistoria.titulo
    this.descripcion = distribuidor.contenidoNuestraHistoria.descripcion
    this.subtituloA = distribuidor.contenidoNuestraHistoria.subtituloA
    this.subtituloB = distribuidor.contenidoNuestraHistoria.subtituloB
  }

  ngOnInit(): void {

  }

}
